{
  "Just a second, we're getting Weave ready for you...": "Just a second, we're getting Weave ready for you...",
  "begin-setup": {
    "Continue to Setup": "Continue to Setup",
    "Let's set up your account": "Let's set up your account",
    "Welcome to Weave": "Welcome to Weave"
  },
  "signup-form": {
    "An error occured. Try logging in again.": "An error occured. Try logging in again.",
    "Create Account": "Create Account",
    "Create Your Account": "Create Your Account",
    "EMAIL": "EMAIL",
    "Exclude first name": "Exclude first name",
    "Exclude last name": "Exclude last name",
    "Exclude user email": "Exclude user email",
    "FIRST NAME": "FIRST NAME",
    "LAST NAME": "LAST NAME",
    "MOBILE NUMBER": "MOBILE NUMBER",
    "SET PASSWORD": "SET PASSWORD",
    "Secure Password": "Secure Password",
    "Something went wrong": "Something went wrong",
    "Successfully created account.": "Successfully created account.",
    "Text me a link to download the Weave Mobile App.": "Text me a link to download the Weave Mobile App.",
    "This is a one-time message from Weave. Message and data rates may apply. Reply Help for support or Stop to opt out. Your info will not be shared with third parties.": "This is a one-time message from Weave. Message and data rates may apply. Reply Help for support or Stop to opt out. Your info will not be shared with third parties.",
    "{{count}} characters minimum_one": "{{count}} character minimum",
    "{{count}} characters minimum_other": "{{count}} characters minimum"
  },
  "signup-resend": {
    "A new link was sent to {{email}}": "A new link was sent to {{email}}",
    "An error occurred while sending the link. Please try again.": "An error occurred while sending the link. Please try again.",
    "Click below to send a new link to {{email}}": "Click below to send a new link to {{email}}",
    "Link sent successfully.": "Link sent successfully.",
    "Send now": "Send now",
    "This link will expire in 15 minutes. Come back soon!": "This link will expire in 15 minutes. Come back soon!",
    "Uh oh! This link has expired.": "Uh oh! This link has expired."
  }
}
